import { RequestAction, createRequestActionCreators, createAction } from 'helpers/actionsHelpers'
import { Subscription } from 'interfaces/subscription'
import { SimpleAction } from 'interfaces/action'


type CreateStripePaymentMethodRequest = {
  amount: number
}
type CreateStripePaymentMethodResponse =
  & Subscription
  & {}
export const CREATE_STRIPE_PAYMENT_METHOD = 'CREATE_STRIPE_PAYMENT_METHOD' as const
export type CreateStripePaymentMethod = RequestAction<typeof CREATE_STRIPE_PAYMENT_METHOD, CreateStripePaymentMethodRequest, CreateStripePaymentMethodResponse>
export const createStripePaymentMethodActionCreator = createRequestActionCreators<
  typeof CREATE_STRIPE_PAYMENT_METHOD,
  CreateStripePaymentMethodRequest,
  CreateStripePaymentMethodResponse
>(CREATE_STRIPE_PAYMENT_METHOD)

type PatchStripeSubscriptionRequest = {
  amount: number
}
type PatchStripeSubscriptionResponse =
  & Subscription
  & {}
export const PATCH_STRIPE_PAYMENT_METHOD = 'PATCH_STRIPE_PAYMENT_METHOD' as const
type PatchStripePaymentMethod = RequestAction<typeof PATCH_STRIPE_PAYMENT_METHOD, PatchStripeSubscriptionRequest, PatchStripeSubscriptionResponse>
export const patchStripePaymentMethodActionCreator = createRequestActionCreators<
  typeof PATCH_STRIPE_PAYMENT_METHOD,
  PatchStripeSubscriptionRequest,
  PatchStripeSubscriptionResponse
>(PATCH_STRIPE_PAYMENT_METHOD)


export const CLEANUP_STRIPE_PATCH = 'CLEANUP_STRIPE_PATCH' as const
export const cleanupStripePatchActionCreator = (): SimpleAction<typeof CLEANUP_STRIPE_PATCH> => createAction(CLEANUP_STRIPE_PATCH)
type CleanupStripePatch = ReturnType<typeof cleanupStripePatchActionCreator>


export type StripeAction =
  | CreateStripePaymentMethod
  | PatchStripePaymentMethod
  | CleanupStripePatch
